import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@data/store';

export const deliveryReceiptSelector = () =>
  createSelector(
    [(state: RootState) => state],
    state => state.deliveryReceipt || null
  );
